import cartService from "../services/cart.service";
import { formatProductPriceFields } from "../helper";
import { generateDummyProducts } from "./dummyProductGenerator";

export function normalizeOfferProductId(product) {
  const raw =
    product?.id ??
    product?.product_id ??
    product?.admin_graphql_api_id ??
    "";
  const str = String(raw);
  if (!str) return "";
  return str.includes("/") ? str.split("/").pop() : str;
}

export function prependCurrentPageProduct(currentProduct, offerProducts = []) {
  if (!currentProduct) return Array.isArray(offerProducts) ? offerProducts : [];
  const currentId = normalizeOfferProductId(currentProduct);
  const rest = (Array.isArray(offerProducts) ? offerProducts : []).filter(
    (product) => {
      if (!currentId) return true;
      return normalizeOfferProductId(product) !== currentId;
    }
  );
  return [currentProduct, ...rest];
}

export function buildFbtCurrentPagePreviewProduct() {
  const [dummy] = generateDummyProducts(1);
  return {
    ...dummy,
    id: "weupsell-fbt-current-page-preview",
    title: "Current page product",
    handle: "current-page-product",
    __weupsellFbtCurrentPage: true,
  };
}

/**
 * Shopify /products/{handle}.js returns money in cents. Offer catalog + PriceBlock
 * expect major units (dollars) — convert before prepending into FBT.
 */
export function normalizeCurrentPageProductForOffer(product) {
  if (!product || typeof product !== "object") return null;
  if (product.__weupsellPricesInMajorUnits === true) return product;
  const normalized = formatProductPriceFields({ ...product });
  return {
    ...normalized,
    __weupsellPricesInMajorUnits: true,
    __weupsellFbtCurrentPage: true,
  };
}

/**
 * Resolve the storefront PDP product for FBT “include current page product”.
 */
export async function resolveCurrentPageProduct() {
  const cached = window?.__weupsellProduct;
  if (cached?.id && Array.isArray(cached?.variants) && cached.variants.length) {
    return normalizeCurrentPageProductForOffer(cached);
  }

  const match = String(window?.location?.pathname || "").match(
    /\/products\/([^/?#]+)/
  );
  if (!match?.[1]) {
    return cached ? normalizeCurrentPageProductForOffer(cached) : null;
  }

  try {
    const product = await cartService.fetchProductByHandle(match[1]);
    const source = product || cached;
    return source ? normalizeCurrentPageProductForOffer(source) : null;
  } catch (_) {
    return cached ? normalizeCurrentPageProductForOffer(cached) : null;
  }
}
